<template>
  <section :id="id" class="blog-list-item">
    <h2 class="item-title"><router-link :to="postLink">{{title}}</router-link></h2>
    <div class="item-meta">
      <span class="date">{{formattedDate}}</span> &bull; <span class="read-time">{{readTime}}</span>
    </div>
    <p class="item-excerpt">
      <Markdown :source="excerpt" />
    </p>
  </section>
</template>

<style lang="stylus" scoped>

</style>

<script>
import Markdown from './Markdown'
import moment from 'moment'

export default {
  props: {
    id: String,
    date: Date,
    title: String,
    excerpt: String
  },
  computed: {
    postLink () {
      return `/blog/${this.id}`
    },
    formattedDate () {
      const date = moment(this.date)
      return 'posted ' + date.fromNow()
    },
    readTime () {
      const wordCount = this.excerpt.split(' ')
        .filter((n) => n !== '')
        .length

      const div = wordCount / 200
      const mod = div % 1
      const time = mod > 0.5 ? Math.ceil(div) : Math.floor(div)

      if (time < 1) {
        return 'less than 1 minute read'
      } else {
        return `${time} minute read`
      }
    }
  },
  components: {
    Markdown
  }
}
</script>
